import { render, staticRenderFns } from "./VaultBox.vue?vue&type=template&id=aa55c54c"
import script from "./VaultBox.vue?vue&type=script&lang=js"
export * from "./VaultBox.vue?vue&type=script&lang=js"
import style0 from "./VaultBox.vue?vue&type=style&index=0&id=aa55c54c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports